import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { scrollOffset: Number };

  connect() {
    this.button = this.element;
    this.toggleVisibility();
    window.addEventListener("scroll", this.toggleVisibility.bind(this));
  }

  disconnect() {
    window.removeEventListener("scroll", this.toggleVisibility.bind(this));
  }

  toggleVisibility() {
    if (window.scrollY > (this.scrollOffsetValue || 200)) {
      this.button.classList.remove("hidden");
    } else {
      this.button.classList.add("hidden");
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}